import { useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  CustomTabPanel,
  StyledTab,
  StyledTabs,
  a11yProps,
} from "../Common/UI/TabPanel";

import { HeaderStyle } from "../Common/styles/header";
import { useQuery } from "../../utils/hooks";
import PlatformUrlLoader from "./UserUrlLoader";
import PlatformUrlSetter from "./UserUrlSetter";
import { useNavigate } from "react-router-dom";
import OAuth from "./Tabs/OAuth";
import General from "./Tabs/General";
import ChangePassword from "./Tabs/ChangePassword";
import BackButton from "../Common/UI/BackButton";

const UserSettings = () => {
  const navigate = useNavigate();
  const queryType = useQuery().get("type");

  const [type, setType] = useState(queryType ?? "general");
  const [urlLoaded, setUrlLoaded] = useState<boolean>(false);

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return urlLoaded ? (
    <>
      <Box sx={HeaderStyle}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <BackButton onClick={handleBack} />
          <Typography variant="h2" color="text.primary">
            User Settings
          </Typography>
        </Box>
      </Box>
      <>
        <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
          <StyledTabs value={type} onChange={handleChange}>
            <StyledTab label="General" value="general" {...a11yProps(0)} />
            <StyledTab
              label="Password & Security"
              value="password_security"
              {...a11yProps(1)}
            />
            <StyledTab
              label="Mahalo EDC API"
              value="mahalo_edc_api"
              {...a11yProps(2)}
            />
          </StyledTabs>
        </Box>
        <Box sx={{ p: 2.5, overflow: "auto", height: "calc(100vh - 181px)" }}>
          <CustomTabPanel value={type} index={"general"}>
            <General />
          </CustomTabPanel>
          <CustomTabPanel value={type} index={"password_security"}>
            <ChangePassword />
          </CustomTabPanel>
          <CustomTabPanel value={type} index={"mahalo_edc_api"}>
            <OAuth />
          </CustomTabPanel>
        </Box>
      </>
      <PlatformUrlSetter type={type} />
    </>
  ) : (
    <PlatformUrlLoader setType={setType} setUrlLoaded={setUrlLoaded} />
  );
};

export default UserSettings;
